import { useMemo, useState } from "react";

/**
 * Renders email HTML in a sandboxed iframe: no scripts, no same-origin access, links open in a new tab.
 * Remote images are blocked until the reader asks for them, so tracking pixels don't fire on open.
 */
export function EmailFrame({ html }: { html: string }) {
  const [showImages, setShowImages] = useState(false);
  const hasRemoteImages = useMemo(() => /<img[^>]+src=["']?https?:/i.test(html) || /url\(\s*['"]?https?:/i.test(html), [html]);

  const srcDoc = useMemo(() => {
    const imgSrc = showImages ? "https: data:" : "data:";
    const csp = `default-src 'none'; img-src ${imgSrc}; style-src 'unsafe-inline'; font-src https: data:`;
    return `<!doctype html><html><head><meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="${csp}"><base target="_blank"><style>body{margin:0;padding:16px;font:15px/1.5 system-ui,sans-serif;color:#1f2328;background:#fff;word-wrap:break-word}img{max-width:100%;height:auto}</style></head><body>${html}</body></html>`;
  }, [html, showImages]);

  return (
    <div className="email-frame">
      {hasRemoteImages && !showImages && (
        <div className="images-bar">
          <span className="muted small">Remote images are hidden to protect your privacy.</span>
          <button className="btn btn-small" onClick={() => setShowImages(true)}>
            Show images
          </button>
        </div>
      )}
      <iframe title="Email content" sandbox="allow-popups allow-popups-to-escape-sandbox" srcDoc={srcDoc} />
    </div>
  );
}
